import { forwardRef } from 'react';
import { useInterstateTheme } from '../InterstateThemeProvider';
import { Box } from '@mui/material';
import { spinnerLighStyleBuilder, spinnerTextStyleBuilder } from './interstitialContentStyleBuilder';
import { Spinner } from '../Spinner/Spinner';
import { idBuilder } from '../internal';
import * as CONSTANTS from '../InterstitialOverlay/InterstitialOverlay/interstitialOverlayConstants';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const InterstitialContent = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    fullScreen,
    id,
    message,
    size,
    ...rest
  } = _ref;
  const theme = useInterstateTheme();
  return /*#__PURE__*/_jsxs(Box, {
    sx: spinnerLighStyleBuilder(theme, size, fullScreen),
    id: idBuilder('interstitial-content-root', id),
    "data-testid": idBuilder('interstitial-content-root', rest['data-testid']),
    children: [/*#__PURE__*/_jsx(Spinner, {
      size: size === 'large' ? CONSTANTS.LARGE_SPINNER_SIZE : CONSTANTS.SMALL_SPINNER_SIZE,
      id: id,
      "data-testid": rest['data-testid']
    }), message && /*#__PURE__*/_jsx(Box, {
      sx: spinnerTextStyleBuilder(theme, size),
      children: message
    })]
  });
});
InterstitialContent.displayName = 'InterstitialContent';